import React, {useState} from 'react';
import {TextFieldProps} from '@material-ui/core';
import {StudioSearch} from '../../base-components/StudioSearch';
import {ToggleButton, ToggleButtonGroup} from '@material-ui/lab';
import {Sort, ViewListRounded} from '@material-ui/icons';
import {ViewId} from '../../base-components/StudioDataset/FileViewer';
import {Dataset} from '../../types/dataService/Dataset';
import ImageListFilter, {
  FilterProps,
  ImageLabelStateId,
  SortId,
} from '../DatasetEdit/DetectionStep/ImageListFilter';
import {VIEW_TYPE} from '../../base-components/StudioDataset/const';
import {SplitNav} from './SplitNav';
import {DataSplitType} from '../../types/dataset/Dataset';
import {RootState} from '../../store';
import {useSelector} from 'react-redux';

export const Header = ({
  view,
  search,
  dataset,
  onView = () => {},
  onSearch = () => {},
  onFilter = () => {},
}: {
  onView?(val: ViewId): void;
  dataset?: Dataset;
  view: ViewId;
  search?: string | undefined;
  onSearch?: (val: string) => void;
  onFilter?: (args: FilterProps) => void;
}) => {
  const metadata = useSelector((state: RootState) => state.datasetMetadata);
  const splits = metadata.splits?.distributionTotals;

  const [sortBy, setSortBy] = useState<SortId>('recentlyAddedAsc');
  const [imageLabelStateBy, setImageLabelStateBy] = useState<ImageLabelStateId[]>([
    'labeled',
    'notLabeled',
  ]);
  const [splitType, setSplitType] = useState<DataSplitType>('TRAIN');

  const onFilterChange = (args: FilterProps) => {
    const {groupId, value} = args;
    switch (groupId) {
      case 'sortBy':
        // TODO. Adjust StudiosetViewer to accept parametareized sorting intructions
        setSortBy(value as SortId);
        break;
      case 'imageLabelStateBy':
        setImageLabelStateBy(value as ImageLabelStateId[]);
        break;
    }
    onFilter(args);
  };
  const onFilterReset = () => {
    setSortBy('recentlyAddedAsc');
    setImageLabelStateBy(['labeled', 'notLabeled']);
  };

  const onSplitChange = (type: DataSplitType) => {
    setSplitType(type);
    onFilter({
      groupId: 'split',
      id: 'split',
      value: type,
    });
  };

  return (
    <div className="dataset-view__menu">
      <div className="dataset-view__count">
        <SplitNav
          value={splitType}
          totalImages={dataset?.binaryTotal || 0}
          onChange={onSplitChange}
          trainDistribution={Number(splits?.['TRAIN'])}
          validationDistribution={Number(splits?.['VALIDATION'])}
          testingDistribution={Number(splits?.['TEST'])}
        />
      </div>
      <LabelSearch labelField={search} onChange={e => onSearch(e.target.value)} />
      <ImageListFilter
        sortBy={sortBy}
        imageLabelStateBy={imageLabelStateBy}
        disabled={view === VIEW_TYPE.LABEL}
        iconSize="medium"
        onChange={onFilterChange}
        onReset={onFilterReset}
      />
      <ToggleButtonGroup
        value={view}
        exclusive
        onChange={(_, newView) => newView && onView(newView)}
        aria-label="text alignment"
      >
        <ToggleButton value="list" aria-label="list view">
          <ViewListRounded />
        </ToggleButton>
        <ToggleButton value="label" aria-label="sort by label">
          <Sort />
        </ToggleButton>
      </ToggleButtonGroup>
    </div>
  );
};

const LabelSearch = (props: {
  labelField?: string;
  onChange: TextFieldProps['onChange'];
}) => {
  return (
    <div className="dataset-view__search">
      <StudioSearch
        placeholder="Search by label"
        onChange={props.onChange}
        value={props.labelField}
      />
    </div>
  );
};
